
import * as api from "../../../../api"; 


  
export const createNewMockTest = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewMockTest(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}
  
export const getQuizDataByQuizId = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getQuizDataByQuizId(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}



  
export const createNewMockSection = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewMockSection(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}
  
export const getSectionsByQuizId = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getSectionsByQuizId(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}


export const createNewQuestion = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewQuestion(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}
  
export const getQuestionsByQuizId = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getQuestionsByQuizId(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}



export const createNewQuestionsOption = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewQuestionsOption(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}

export const getOptionsByQuestionId = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getOptionsByQuestionId(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}




export const getAllQuizSectionsQuestionsOptionsInOne = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getAllQuizSectionsQuestionsOptionsInOne(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}


export const createNewMockTopic = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewMockTopic(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}

export const createNewEntryToMockTopic = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewEntryToMockTopic(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}

export const createNewRichContent = (post) => async (dispatch)=>{
    try {
        const {data } = await api.createNewRichContent(post);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}



